/**
 * @author Rohman Widiyanto
 * @email rohmansca@gmail.com
 * @create date 2022-01-15 15:29:27
 * @modify date 2022-02-14 20:25:11
 * @desc Style for sign-in page
 */

import { Theme } from '@mui/material'
import { createStyles, makeStyles } from '@mui/styles'
import { verticalCentered } from 'assets'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonWrapper: {
      ...verticalCentered,
      justifyContent: 'space-evenly',
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(3)
    },
    button: {
      width: '200px',
      marginRight: theme.spacing(1)
    }
  })
)